import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { dietTypeService } from "../../../services/settings-services";

const initialState = {
  dietTypes: [],
  status: null,
  error: null,
  trigger: 0,
};

const getAllDietTypes = createAsyncThunk(
  "dietTypeSlice/getAllDietTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await dietTypeService.getAll();
      return response;
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const dietTypeSlice = createSlice({
  name: "dietTypeSlice",
  initialState,
  reducers: {
    changeTrigger: (state, action) => {
      state.trigger = state.trigger + 1;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAllDietTypes.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(getAllDietTypes.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.dietTypes = action.payload;
      })
      .addCase(getAllDietTypes.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      }),
});

const { reducer: dietTypeReducer, actions } = dietTypeSlice;
const dietTypeActions = {
  ...actions,
  getAllDietTypes,
};

export { dietTypeReducer, dietTypeActions };

